import { LandThumbnail, LandThumbnailSkin } from '@cibo/ui'
import { Box, Stack, Typography } from '@mui/material'
import { GridColDef, GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid-pro'
import { TFunction } from 'i18next'

const THUMBNAIL_SIZE = 44

export const fieldThumbnailNameColumn = ({
  t,
  columnProps,
}: {
  t: TFunction
  columnProps?: Partial<GridColDef>
}) => ({
  field: 'field',
  headerName: t('field', { ns: '@cibo/landmanager/FieldColumns' }),
  minWidth: 180,
  flex: 1,
  type: 'string',
  valueGetter: (params: GridValueGetterParams) => params.row.name,
  renderCell: (params: GridRenderCellParams) => {
    return params.row.isRollup ? (
      <Stack direction="row" spacing={1} ml={2}>
        <Typography fontWeight={600}>
          {t('answerForAll', { ns: '@cibo/landmanager/FieldColumns' })}
        </Typography>
      </Stack>
    ) : (
      <Stack direction="row" spacing={1} ml={2}>
        <Box style={{ width: THUMBNAIL_SIZE, height: THUMBNAIL_SIZE }}>
          <LandThumbnail
            landProfile={params.row}
            width={THUMBNAIL_SIZE}
            height={THUMBNAIL_SIZE}
            skin={LandThumbnailSkin.SMALL}
          />
        </Box>
        <Stack>
          <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{`${
            params.row.name || ''
          }`}</Typography>
          <Typography variant="caption" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{`${
            params.row.ownedBy?.userPrimaryEmail || ''
          }`}</Typography>
        </Stack>
      </Stack>
    )
  },
  ...columnProps,
})
